<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        Edit Portal Company
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="submit" class="form-horizontal">
        <TextFormGroup
            v-model="data.legacy_reference"
            name="legacy_reference"
            label="Legacy Reference"
            :error="(errors.legacy_reference || [])[0]"
        />

        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            :error="(errors.name || [])[0]"
        />

        <CkEditorFormGroup
            v-model="data.description"
            name="description"
            label="Description"
            :error="(errors.description || [])[0]"
            :toolbar="['bold', 'italic', 'link']"
        />

        <TextFormGroup
            v-model="data.email"
            name="email"
            label="Email"
            :error="(errors.email || [])[0]"
        />

        <TextFormGroup
            v-model="data.phone"
            name="phone"
            label="Phone"
            :error="(errors.phone || [])[0]"
        />

        <TextFormGroup
            v-model="data.website"
            name="website"
            label="Website"
            :error="(errors.website || [])[0]"
        />

        <TextFormGroup
            v-model="data.address"
            name="address"
            label="Address"
            :error="(errors.address || [])[0]"
        />

        <TextFormGroup
            v-model="data.zip_code"
            name="zip_code"
            label="Zip Code"
            :error="(errors.zip_code || [])[0]"
        />

        <TextFormGroup
            v-model="data.city"
            name="city"
            label="City"
            :error="(errors.city || [])[0]"
        />

        <SelectFormGroup
            v-model="data.country"
            name="country"
            label="Country"
            :error="(errors.country || [])[0]"
            :options="countryOptions"
            :nullable="true"
        />

        <TextFormGroup
            v-model="data.facebook_url"
            name="facebook_url"
            label="Facebook URL"
            :error="(errors.facebook_url || [])[0]"
        />

        <TextFormGroup
            v-model="data.linkedin_url"
            name="linkedin_url"
            label="LinkedIn URL"
            :error="(errors.linkedin_url || [])[0]"
        />

        <TextFormGroup
            v-model="data.twitter_url"
            name="twitter_url"
            label="Twitter URL"
            :error="(errors.twitter_url || [])[0]"
        />

        <TextFormGroup
            v-model="data.instagram_url"
            name="instagram_url"
            label="Instagram URL"
            :error="(errors.instagram_url || [])[0]"
        />

        <TextFormGroup
            v-model="data.pinterest_url"
            name="pinterest_url"
            label="Pinterest URL"
            :error="(errors.pinterest_url || [])[0]"
        />

        <RadioFormGroup
            v-model="data.is_editorial"
            name="is_editorial"
            label="Is Editorial"
            :error="(errors.is_editorial || [])[0]"
            :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
            help-text="A flag indicating if this portal company is the editorial portal company."
        />

        <GalleryFormGroup
            v-model="data.image_id"
            name="image_id"
            label="Image"
            :error="(errors.image_id || [])[0]"
        />

        <GalleryFormGroup
            v-model="data.logo_image_id"
            name="logo_image_id"
            label="Logo Image"
            :error="(errors.logo_image_id || [])[0]"
        />

        <SelectFormGroup
            v-model="data.user_id"
            name="user_id"
            label="User"
            :error="(errors.user_id || [])[0]"
            :options="userOptions"
            :nullable="true"
        />

        <TextFormGroup
            v-model="data.path"
            name="path"
            label="Path"
            :error="(errors.path || [])[0]"
        />

        <hr>

        <div class="form-group">
          <div class="col-sm-offset-8 col-sm-12">
            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>

            <button
                v-if="!portalCompany.attributes.path"
                type="button"
                class="btn btn-default"
                @click="publish"
            >
              Publish
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Horizontal/CkEditor'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    CkEditorFormGroup,
    GalleryFormGroup,
    RadioFormGroup,
    SelectFormGroup,
    TextFormGroup,
  },

  mixins: [Errors],

  model: {
    prop: 'company',
    event: 'company-updated'
  },

  props: {
    company: {
      required: true
    },

    portalCompany: {
      required: true
    },

    countries: {
      required: true
    },

    users:{
      required: true
    }
  },

  data() {
    return {
      data: {...this.portalCompany.attributes},
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    countryOptions() {
      return this.countries.map(country => {
        return {
          value: country.id,
          label: country.attributes.name
        }
      })
    },

    userOptions() {
      return this.users.map(user => {
        return {
          value: user.id,
          label: user.attributes.full_name
        }
      })
    }
  },

  watch: {
    portalCompany() {
      this.data = {...this.portalCompany.attributes}
    }
  },

  methods: {
    submit() {
      http.put('/api/v2/portal-companies/' + this.portalCompany.id, this.data)
          .then(response => {
            notify.success('The portal company was saved')

            this.$emit('updated', response.data.data)
          })
          .catch(this.catchValidationErrors)
    },

    publish() {
      http.post('/api/v2/portal-companies/' + this.portalCompany.id + '/publish')
          .then(response => {
            notify.success('The portal company was published')

            this.$emit('updated', response.data.data)
          })
          .catch(this.catchValidationErrors)
    },
  }
}
</script>
